function handleCartIconUpdate(itemsCount) {
  const cartIcon = document.querySelector(".header__icon--cart");
  if (!cartIcon) return;

  if (itemsCount > 0) {
    cartIcon.classList.add("cart__toggle--has-items");
  } else {
    cartIcon.classList.remove("cart__toggle--has-items");
  }
}

// Selects the element and parses the JSON variant list from the product list.
const cartFoot = document.querySelector(".cart-drawer__foot.cart__foot");
const jsonProduct = JSON.parse(
  document.querySelector("#gift__products").innerHTML
);
const jsonVariantList = JSON.parse(
  document.querySelector("#product-list_variant").innerHTML
);
// Removes empty field variants from the variant list.
const removeEmptyField = jsonProduct.filter((el) => el.free !== "");
const removeEmptyFieldVariantList = jsonVariantList.filter(
  (el) => el.free !== ""
);
const allJson = [...removeEmptyField, ...removeEmptyFieldVariantList];

allJson.forEach((obj) => {
  obj.free = obj.free
    .split(",")
    .map((id) => id.trim())
    .filter((id) => id !== "");
});

async function handleCartUpdate(items) {
  handleCartIconUpdate(items.length);

  // Prepare updates for free products.
  const updates = {};

  // Check if free cart quantities are properly set.
  const freeProducts = items.filter((item) => item.price === 0);
  for (const freeProduct of freeProducts) {
    const { quantity, id } = freeProduct;
    if (quantity > 1) {
      updates[id] = 1;
    }
  }
   const hasBooklet = items.filter((item) =>
     item.variant_id === 48079822979227
  )
   
  // Check if subscription items corresponding to free products are in cart.
  const subscriptionItems = items.filter((item) => item.selling_plan_allocation);
  /*
  const subscriptionItems = items.filter((item) =>
    item.selling_plan_allocation !== null
  );*/
  const subscriptionItemIds = subscriptionItems.map((item) =>
    Number(item.product_id)
  ); // FIX: product_id

  for (const freeProduct of freeProducts) {
    if (hasBooklet && freeProduct.product_type?.toLowerCase().includes("gel")) {
        continue;
      }

    const rules = allJson.filter(
      (obj) =>
        obj.free.some((f) => Number(f) === Number(freeProduct.product_id)) // FIX: product_id
    );

    let hasParent = false;

    for (const rule of rules) {
      const mainIds = rule.main.split(",").map((id) => Number(id.trim()));
      if (mainIds.some((id) => subscriptionItemIds.includes(id))) {
        hasParent = true;
        break;
      }
    }

    // Add inside handleCartUpdate, right before "if (!hasParent)" (around line 73)
    console.log('DEBUG free gift check:', {
      freeProductId: freeProduct.product_id,
      freeProductVariantId: freeProduct.id,
      matchingRules: rules,
      subscriptionItemIds,
      mainIdsFromRules: rules.map(r => r.main.split(",").map(id => id.trim())),
      hasMatch: rules.some(rule => {
        const mains = rule.main.split(",").map(id => Number(id.trim()));
        return mains.some(m => subscriptionItemIds.includes(m));
      })
    });

    if (!hasParent) {
      document.querySelector(".body-loader").classList.add("active");
      updates[freeProduct.id] = 0;
    }
  }

  if (Object.keys(updates).length === 0) return;

  // If there are updates, update the cart.
  try {
    if (cartFoot) {
      cartFoot.classList.add("is-disabled");
    }
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      }
    );
    if (!response.ok) throw new Error("Failed to update cart");

    const data = await response.json();

    handleCartIconUpdate(data.item_count);
    // publish(PUB_SUB_EVENTS.cartUpdate, {
    //   source: "free-gift-interceptor",
    //   cartData: data,
    // });

    document.dispatchEvent(new CustomEvent("cart:update")); // Trigger cart UI updates.
  } catch (error) {
    console.error("Error updating cart:", error);
  } finally {
    if (cartFoot) {
      cartFoot.classList.remove("is-disabled");
    }
  }
}

subscribe(window.PUB_SUB_EVENTS?.cartUpdate || 'cart-update', async (event) => {
  // Ensure event has cart data
  const cartData = event.cartData;

  const items = cartData?.items || [];
  await handleCartUpdate(items);
});

// function checkInCart(cartItems) {
//   const mainIdsInCart = cartItems
//     .filter((item) => item.hasOwnProperty("selling_plan_allocation"))
//     .map((item) => Number(item.product_id));

//   const freeProductsInCart = cartItems.filter((item) =>
//     allJson.some((obj) =>
//       obj.free.some((f) => Number(f) === Number(item.product_id))
//     )
//   );

//   const itemsToRemove = [];

//   console.log(freeProductsInCart, cartItems, allJson);

//   for (const freeItem of freeProductsInCart) {
//     const relatedRules = allJson.filter((obj) =>
//       obj.free.some((f) => Number(f) === Number(freeItem.product_id))
//     );

//     let shouldKeep = false;

//     for (const rule of relatedRules) {
//       const mainIds = rule.main.split(",").map((id) => Number(id.trim()));
//       const hasParent = mainIds.some((id) => mainIdsInCart.includes(id));
//       if (hasParent) {
//         shouldKeep = true;
//         break;
//       }
//     }

//     if (!shouldKeep) {
//       itemsToRemove.push(freeItem.id.toString());
//     }
//   }

//   return {
//     shouldClean: itemsToRemove.length > 0,
//     triggerItems: itemsToRemove,
//   };
// }

// let motherBundleRemoved = false;

// function handleRemoveButtons() {
//   const removeButtons = document.querySelectorAll("a.cart__item__remove");
//   removeButtons.forEach((button) => {
//     button.onclick = (e) => {
//       const id = button.getAttribute("data-id");
//       const correspondingProduct = document.querySelector(
//         `.cart__item[data-key-item="${id}"]`
//       );
//       let productTitle =
//         correspondingProduct.querySelector(".cart__item__title");
//       if (productTitle) {
//         productTitle = productTitle.textContent.trim();

//         const motherBundlesJson = JSON.parse(
//           document.querySelector("#mother__bundles").innerHTML
//         );
//         const isMotherBundle = motherBundlesJson.some((el) =>
//           el.title === productTitle ? productTitle : false
//         );

//         if (isMotherBundle || productTitle === "IMMUNE SUPPORT 5 IN 1") {
//           motherBundleRemoved = true;
//         }

//         if (motherBundleRemoved) {
//           const stillExists = (bundleTitle) =>
//             new Promise((res, rej) => {
//               const currentProductList = document.querySelectorAll(
//                 ".cart__item__title a"
//               );
//               currentProductList.forEach((title) => {
//                 const trimmedTitle = title.textContent.trim();
//                 if (trimmedTitle === productTitle) {
//                   rej("Not yet rerendered.");
//                 } else {
//                   res("Rerendered");
//                 }
//               });
//               res(bundleTitle);
//             });

//           const resultInterval = setInterval(async () => {
//             const result = await stillExists(productTitle);
//             if (result === "Rerendered") {
//               clearInterval(resultInterval);

//               const freeProducts = document.querySelectorAll(
//                 ".cart__item.free_product"
//               );
//               if (freeProducts) {
//                 freeProducts.forEach((product) => {
//                   const clickEvent = new Event("click", { bubbles: true });
//                   product
//                     .querySelector(".cart__item__remove")
//                     .dispatchEvent(clickEvent);
//                 });
//               }
//               motherBundleRemoved = false;
//             }
//           }, 1000);
//         }
//       }
//     };
//   });
// }

// handleRemoveButtons();

// // Checks the quantity of free products and updates the cart if needed.
// function checkQuantityAndDelete(cartItem) {
//   const updateDataFreeProduct = {};
//   const freeProducts = cartItem.filter((el) => el.price == 0);
//   freeProducts.forEach((element) => {
//     const { quantity, id } = element;
//     if (quantity >= 2) {
//       updateDataFreeProduct[id] = 1;
//     }
//   });
//   if (Object.keys(updateDataFreeProduct).length != 0) {
//     const dataUpdateForm = {
//       updates: updateDataFreeProduct,
//     };
//     originalFetch(window.Shopify.routes.root + "cart/update.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(dataUpdateForm),
//     })
//       .then((res) => {
//         console.log("update free products");
//         console.log(res);
//         return res;
//       })
//       .then((res) => {
//         console.log(res.json());
//         setTimeout(() => {
//           document.dispatchEvent(new CustomEvent("cart:update"));
//         }, 1000);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }
// }

// let isDeletingFreeProducts = false;
// // Event handler function for the 'cart:remove' event.
// const deleteFreeProduct = async (event) => {
//   const items = event.detail
//     ? event.detail.cartJson.items
//     : await fetchCartItems();
//   checkQuantityAndDelete(items);

//   const { shouldClean, triggerItems } = checkInCart(items);

//   let variantListSelectors = [];

//   if (shouldClean) {
//     variantListSelectors = triggerItems;
//   }

//   if (variantListSelectors.length > 0) {
//     console.log(
//       variantListSelectors.length,
//       "variantListSelectors.length in deleteFreeProduct"
//     );

//     if (cartFoot) {
//       cartFoot.classList.add("is-disabled");
//     }

//     //remove items from cart variantListSelectors one by one
//     // const fetchPromises = variantListSelectors.map(async (el) => {
//     //   if (!el) return;

//     //   const removeData = {
//     //     id: el,
//     //     quantity: 0,
//     //   };

//     //   const response = await originalFetch(
//     //     window.Shopify.routes.root + "cart/change.js",
//     //     {
//     //       method: "POST",
//     //       headers: { "Content-Type": "application/json" },
//     //       body: JSON.stringify(removeData),
//     //     }
//     //   );

//     //   if (!response.ok) {
//     //     console.error(`error id: ${removeData.id}`);
//     //   }
//     // });

//     const updates = Object.fromEntries(
//       variantListSelectors.map((item) => [item, 0])
//     );

//     const fetchPromise = originalFetch(
//       window.Shopify.routes.root + "cart/update.js",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ updates }),
//       }
//     );

//     console.log(updates);

//     if (isDeletingFreeProducts) return;

//     try {
//       // await Promise.all(fetchPromises);
//       await fetchPromise;
//       document.dispatchEvent(
//         new CustomEvent("cart:update_remove", { bubbles: true })
//       );
//       setTimeout(() => {
//         document.dispatchEvent(new CustomEvent("cart:update"));
//       }, 1000);
//       console.log("All free products removed successfully !!!!");
//       isDeletingFreeProducts = true;
//     } catch (error) {
//       console.error("error", error);
//     } finally {
//       if (cartFoot) {
//         cartFoot.classList.remove("is-disabled");
//       }
//       isDeletingFreeProducts = false;
//     }
//   }
// };

// Run on initial page load
// (async () => {
//   await deleteFreeProduct({});
// })();
